import { render, staticRenderFns } from "./CulturalSpace.vue?vue&type=template&id=4eac6068&scoped=true&"
import script from "./CulturalSpace.vue?vue&type=script&lang=js&"
export * from "./CulturalSpace.vue?vue&type=script&lang=js&"
import style0 from "./CulturalSpace.vue?vue&type=style&index=0&id=4eac6068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eac6068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
